import React from "react";
import "../styles.css";
import Navbar from "./NavBar";

// The green top portion of the header.
// Remove comment around the div emailButton to add a contact email.
const HeaderTop = () => {
  return (
    <div className="headerTop montserratBold">
      <div className="emailButton">info@icaresolutions.ca</div>
    </div>
  );
};

// The bottom blue portion of the header, this contains the logo, nav buttons.

// The main component for the header.
// You only need to load this. It's already in the main app.js, and therefore, on every page.
const Header = ({
  loggedIn,
  setLogin,
  setSelectedSection,
  toggleSidebar,
  setSelectedCareService,
}) => {
  console.log(loggedIn, "header");
  return (
    <>
      <HeaderTop />
      <Navbar
        loggedIn={loggedIn}
        setLogin={setLogin}
        toggleSidebar={toggleSidebar}
        setSelectedSection={setSelectedSection}
        setSelectedCareService={setSelectedCareService}
      />
    </>
  );
};

export default Header;
